import script from "./QRcode.vue?vue&type=script&setup=true&lang=js"
export * from "./QRcode.vue?vue&type=script&setup=true&lang=js"

import "./QRcode.vue?vue&type=style&index=0&id=844cc58c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-844cc58c"]])

export default __exports__